import { Box, Grid, IconButton, makeStyles, Card, Typography, FormControl, NativeSelect } from '@material-ui/core'

import React, { useContext, useState } from 'react'

import CustomButton from './CustomButton'
import CustomDialog from './CustomDialog'
import CustomHeading from './CustomHeading'

import DownloadOptionDialog from './DownloadOptionDialog'
import HeaderWithSideBar from './HeaderWithSideBar'

import SearchContent from './SearchContent'
import Sidebar from '../components/version-4/Sidebar'
import Header from '../components/version-4/Header'
import UploadIcon from '../assets/images/icons/upload.svg'
import AddIcon from '../assets/images/icons/add.svg'
import DownloadIcon from '../assets/images/icons/download.svg'
import FilterIcon from '../assets/images/icons/filter.svg'
import BoxIcon from '../assets/images/icons/box.svg'
import CustomImage from './CustomImage'
import CustomDatePicker from './CustomDatePicker'
import ActiveBoxIcon from '../assets/images/icons/box-active.svg'
import ActiveListIcon from '../assets/images/icons/list-active.svg'
import EditIcon from '../assets/images/icons/edit.svg'
import ListIcon from '../assets/images/icons/list.svg'
import DeleteIcon from '../assets/images/icons/delete.svg'
import { useHistory } from 'react-router'
import CategoryForm from './Forms/Category/CategoryForm'
import CustomDrop from './CustomDrop'
import CustomUpload from './CustomUpload'
import CustomCategory from './CustomCategory'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { UserContext } from '../context api/UserContext'
import InputLabel from '@material-ui/core/InputLabel'
import { FiDownloadCloud } from 'react-icons/fi'
import { CSVLink } from 'react-csv'
import { csvDownloadHelper } from '../utils/csvDownloadHelper'
import BackdropLoader from './BackdropLoader'
import axios from 'axios'
import { backendUrl } from '../shared/API'
import { toastMessage } from '../shared/AlertPopup'
import { formTokenHeader } from '../lib/HeaderHelper'
import Loader from './Loader'


const useStyles = makeStyles((theme) => ({
  analysis: {
    // paddingLeft: '21px',
    // paddingTop: '20px',
    // width: 'calc(100vw-73px)',
    // width: '100%',
    marginTop: '20px',
    backgroundColor: 'white',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },

  table: {
    // paddingRight: '21px',
    // paddingLeft: '21px',
    paddingTop: '20px',
    // marginTop: '20px',
    // padding:'15px'
    width: '100%',
  },

  setting: {
    // paddingLeft: '21px',
    width: 'calc(100vw-233px)',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: 'white',
  },
  icon: {
    width: '22px',
    height: '22px',
    cursor: 'pointer',
    marginLeft: '22px',
    // marginTop: '4px',
  },
  icons: {
    marginLeft: '15px',
    cursor: 'pointer',
  },
  box: {
    paddingRight: '21px',
    paddingLeft: '21px',
    height: '60px',
    // marginTop: '20px',
  },
  underline: {
    borderBottom: '2px solid #F5F8FF',
  },
  heading: {
    fontWeight: 600,
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    border: '1px solid #CCCCCC',
    borderRadius: '5px',
    padding: '0px 4px 0px 4px',
    marginTop: '15px',

    height: 'fit-content',
  },
  selectEmpty: {
    marginTop: '0px',
    border: 'none',
  },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiInput-underline': {
    border: 'none !important',
  },
  '& .MuiInputBase-root.MuiInput-root.MuiInput-underline:before': {
    border: 'none !important',
  },
  '& .MuiInputBase-root.MuiInput-root.MuiInput-underline:after': {
    border: 'none !important',
  },
  'input#date-picker-dialog': {
    fontSize: '12px',
    paddingTop: '0px',
  },
  heading2: { fontWeight: 600, margin: '0px 4px' },
  failedButton: {
    backgroundColor: 'red',
    marginRight: '20px',
    '&:hover': {
      backgroundColor: 'red',
    },
  },
}))

const rankOptions = [
  { value: 1, name: 'Regional' },
  { value: 2, name: 'Zonal' },
  { value: 3, name: 'State' },
  { value: 4, name: 'District' },
  { value: 5, name: 'City' },
  { value: 6, name: 'Area' },
]

export default function Layout({
  children,
  heading,
  searchQuery,
  setSearchQuery,
  selectedDate,
  setSelectedDate,
  headers,
  data,
  handleBulkUpload,
  setFile,
  handleUploadFile,
  openPopup,
  setOpenPopup,
  handleGrid,
  handleTable,
  GridAttend,
  TableAttend,
  home,
  url,
  openDialog,
  setOpenDialog,
  none,
  selectedData,
  deleteData,
  editUrl,
  setDeleteDialog,
  formPopup,
  setFormPopup,
  setMultipleDeleteDialog,
  bulkUpload,
  uploadedfile,
  setUploadedFile,
  heading2,
  url1,
  url2,
  addnone,
  tempHeaderData,
  tempHeaders,
  selectedFrom,
  setSelectedFrom,
  selectedTo,
  setSelectedTo,
  filename = '',
  sampleName = '',
  filterRank = '',
  setFilterRank,
  showEdit,
  downloadLoading = false,
  filterName,
  setFilterName,
  filterNamesOptions = [],
  filterRankOptions = rankOptions,
  BulkUpload,
  sheetName,
  both,
  redirectUrl,
  addData,
  downloadFailed,
  downloadSuccess,
  uploadFileName,
  permissionName,
  setPage,
  uploadLoading = false,
  paginateFront,
  confirm = false,
  openPrompt = false,
}) {

  const classes = useStyles()
  // console.log({ confirm })
  const [loading, setLoading] = useState(false)
  const syncReward = async () => {
    setLoading(true)
    try {
      const token = localStorage.getItem('token')
      console.log(JSON.parse(token))
      const header = formTokenHeader(JSON.parse(token))
      console.log({ header })

      const { data } = await axios.get(`${backendUrl}/Reward/getUserRewards`, header)
      setLoading(false)
      console.log(data)
      toastMessage('Sync Successfull', 'success')
      window.location.reload()
    } catch (error) {
      console.log({ error })
      setLoading(false)
    }
  }
  const history = useHistory()
  const [Opensidebar, setOpensidebar] = React.useState(true)
  const handleOpensidebar = () => {
    setOpensidebar(!Opensidebar)
  }

  const user = useContext(UserContext)
  let permissions = []
  const userFeatures = user.user && user.user.allowedFeatures
  console.log("userFeatures", user.user)
  userFeatures &&
    userFeatures.forEach((val) => {
      if (val.module === permissionName) {
        permissions.push(...val.subPermission)
      }
    })

  if(user?.user?.userType == "COMPANYADMIN" && permissionName == 'SUBSCRIPTIONS'){
    permissions.push("CREATE")
  }

  console.log(permissions);
  //console.log('USER LAY: ', permissions)
  const userType = (user && user.user && user.user.userType === 'COMPANYADMIN') || user.user.userType === 'SUPERADMIN'
  showEdit = showEdit || (user && user.user && user.user.userType === 'COMPANYADMIN')
  let showIcons = selectedData && selectedData.length > 0 ? false : true
  // console.log('uploadLoading : ', uploadLoading)
  console.log({ permissions })
  return (
    <>
      {uploadLoading && <BackdropLoader open={uploadLoading} />}
      <HeaderWithSideBar
        heading={heading}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        open={Opensidebar}
        handleOpen={handleOpensidebar}
        handleGrid={handleGrid}
        handleTable={handleTable}
        GridAttend={GridAttend}
        TableAttend={TableAttend}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      >
        {home ? null : (
          <Card variant="outlined">
            <Box display="flex" justifyContent="space-between" className={classes.box}>
              <Box display="flex" alignItems="center">
                <Box display="flex">
                  <CustomHeading heading={heading} className={classes.heading} url={url1} />
                  {heading2 && (
                    <>
                      <CustomHeading heading=" > " className={classes.heading2} />
                      <CustomHeading heading={heading2} className={classes.heading} />
                    </>
                  )}
                </Box>

                {both ? (
                  <Box display="flex">
                    <div onClick={handleGrid}>
                      <CustomImage image={GridAttend ? ActiveBoxIcon : BoxIcon} className={classes.icon} />
                    </div>
                    {handleTable && (
                      <div onClick={handleTable}>
                        <CustomImage image={GridAttend ? ListIcon : ActiveListIcon} className={classes.icon} />
                      </div>
                    )}
                  </Box>
                ) : (
                  <div onClick={handleTable}>{handleTable && <CustomImage image={GridAttend ? ListIcon : ActiveListIcon} className={classes.icon} />}</div>
                )}
              </Box>

              <Box display="flex" alignContent="center" alignItems="center">
                {!GridAttend && setFilterRank && (
                  <div style={{ display: 'flex' }}>
                    <FormControl>
                      <InputLabel shrink htmlFor="rank">
                        Role
                      </InputLabel>
                      <NativeSelect
                        value={filterRank}
                        onChange={(e) => setFilterRank(e.target.value)}
                        inputProps={{
                          name: 'rank',
                          id: 'rank',
                        }}
                        style={{ width: '100px' }}
                      >
                        <option value="">All</option>
                        {filterRankOptions.map((item) => (
                          <option value={item.value}>{item.name}</option>
                        ))}
                      </NativeSelect>
                    </FormControl>
                  </div>
                )}


                {!GridAttend && setFilterName && (
                  <div style={{ display: 'flex', margin: '0 15px' }}>
                    <FormControl>
                      <InputLabel shrink htmlFor="rank">
                        Employee Name
                      </InputLabel>
                      <NativeSelect
                        value={filterName}
                        onChange={(e) => setFilterName(e.target.value)}
                        inputProps={{
                          name: 'rank',
                          id: 'rank',
                        }}
                        style={{ width: '100px' }}
                      >
                        <option value="">All</option>
                        {filterNamesOptions.map((item) => (
                          <option value={item.id}>{item.name}</option>
                        ))}
                      </NativeSelect>
                    </FormControl>
                  </div>
                )}

                <Box display="flex">
                  {setSelectedDate && (
                    <div
                      style={{
                        marginTop: '15px',
                        marginLeft: '15px',
                        // border: '1px solid #CCCCCC',
                        // height: '34px',
                        // borderRadius: '4px',
                      }}
                    >
                      <CustomDatePicker selectedDate={selectedDate} setSelectedDate={setSelectedDate} maxDate={new Date()} />
                    </div>
                  )}

                  {setSelectedFrom && setSelectedTo && (
                    <React.Fragment>
                      <CustomDatePicker selectedDate={selectedFrom} setSelectedDate={setSelectedFrom} maxDate={new Date()} defaultValue="From" height="37px" />
                      <CustomDatePicker selectedDate={selectedTo} setSelectedDate={setSelectedTo} maxDate={new Date()} defaultValue="To" height="37px" />
                    </React.Fragment>
                  )}

                  {
                  // (
                    (userType 
                    || permissions.includes('DELETE')
                    )
                    // )
                   && selectedData && selectedData.length > 0 
                  && (
                    <Box display="flex" marginTop="13px">
                      <CustomImage image={DeleteIcon} className={classes.icons} onClick={() => setMultipleDeleteDialog(true)} />
                    </Box>
                  )}

                  {(userType || permissions.includes('UPDATE')) && selectedData && selectedData.length === 1 && (
                    <Box display="flex" marginTop="13px">
                      <CustomImage image={EditIcon} className={classes.icons} onClick={confirm ? confirm : () => history.push(editUrl)} />
                    </Box>
                  )}

                  {(userType || permissions.includes('UPLOAD')) && showIcons && sampleName && (
                    <CustomUpload
                      className={classes.icons}
                      heading={heading}
                      tempHeaderData={tempHeaderData}
                      headers={headers}
                      tempHeaders={tempHeaders}
                      sampleName={sampleName}
                      sheetName={sheetName}
                      bulkUpload={bulkUpload}
                      setFileTemp={setFile}
                      redirectUrl={redirectUrl}
                      addData={addData}
                    />
                  )}
                  {/* {downloadFailed && downloadSuccess && ( */}
                  <Box display="flex">
                    {paginateFront && <CustomButton text="Sync" handleSubmit={syncReward} />}
                    {downloadFailed && (
                      <CSVLink {...csvDownloadHelper(downloadFailed.headingValues, downloadFailed.heading, `FAILED-${heading2 ? heading2 : heading}-UPLOAD_DATA`)} style={{ textDecoration: 'none' }}>
                        <CustomButton text="Failed" className={classes.failedButton} icon={<FiDownloadCloud />} />
                      </CSVLink>
                    )}
                    {downloadSuccess && (
                      <CSVLink
                        {...csvDownloadHelper(downloadSuccess.headingValues, downloadSuccess.heading, `SUCCESS-${heading2 ? heading2 : heading}-UPLOAD_DATA`)}
                        style={{ textDecoration: 'none' }}
                      >
                        <CustomButton text="Success" icon={<FiDownloadCloud />} />
                      </CSVLink>
                    )}
                  </Box>
                  {/* )} */}

                  {!GridAttend && showIcons && filename && (
                    <CustomDrop className={classes.icons} heading={heading} data={data} headers={headers} filename={filename} downloadLoading={downloadLoading} />
                  )}

                  {(userType || permissions.includes('CREATE')) && showIcons && url && (
                    <Box display="flex" marginTop="13px">
                      <CustomImage image={AddIcon} className={classes.icons} onClick={() => history.push(url)} />{' '}
                    </Box>
                  )}

        
                </Box>
              </Box>
            </Box>
          </Card>
        )}
        {/* <DownloadOptionDialog open={open} handleClose={handleClose} headers={headers} data={data} heading={heading} /> */}
        <Grid container className={!heading ? classes.setting : classes.analysis}>
          <Grid item md={12}>
            {loading ? <Loader /> : children}
          </Grid>
        </Grid>
        {heading === 'Manage Categories' || heading === 'Manage SubCategory' || heading === 'Manage Products' ? (
          <CustomDialog open={openPopup} handleClose={() => setOpenPopup(false)}>
            <input id="icon-button-file" type="file" onChange={(e) => setFile(e.target.files[0])} />
            <br />
            <br />
            <CustomButton text="Upload" handleSubmit={handleUploadFile} />
          </CustomDialog>
        ) : null}
      </HeaderWithSideBar>
    </>
  )
}
